import util from './_util';

const {request} = util;

export default {
    /**
     * 组织结构
     * */
    // 获取组织机构类型
    zzjgItemType() {
        return request('/zzjg/get_all')
    },
    // 添加
    zzjgItemAdd(data) {
        return request.post('/zzjg/add', data)
    },
    // 删除
    zzjgItemDel(params) {
        return request.delete('/zzjg/delete?ids=' + params)
    },
    // 根据ID查询详情
    zzjgItemGetById(params) {
        return request('/zzjg/get_by_id')
    },
    // 修改
    zzjgItemUpdate(params) {
        return request.put('/zzjg/update', params)
    },
    /**
     * 站点管理
     * */
    // 添加
    zdglAdd(data) {
        return request.post('/zdgl/add', data)
    },

    // 删除
    zdglDel(params) {
        return request.delete('/zdgl/delete?ids=' + params)
    },

    // 修改
    zdglUpdate(params) {
        return request.put('/zdgl/update', params)
    },

    // 获取单位类型
    zdglGetAll() {
        return request.get('/zdgl/get_all')
    },

    // 根据ID查询详情
    zdglGetById(params) {
        return request.get('/zdgl/get_by_id', params)
    },

    /**
     * 检测场所管理
     * */
    // 添加
    jccsglAdd(data) {
        return request.post('/jccs/add', data)
    },

    // 删除
    jccsglDel(params) {
        return request.delete('/jccs/delete?ids=' + params)
    },

    // 修改
    jccsglUpdate(params) {
        return request.put('/jccs/update', params)
    },

    // 获取单位类型
    jccsglGetAll() {
        return request.get('/jccs/get_all')
    },

    // 根据ID查询详情
    jccsglGetById(params) {
        return request.get('/jccs/get_by_id', params)
    },

    /**
     * 用户角色管理
     * */
    // 添加
    yhjsglAdd(data) {
        return request.post('/yhgl/add', data)
    },

    // 删除
    yhjsglDel(params) {
        return request.delete('/yhgl/delete?ids=' + params)
    },

    // 修改
    yhjsglUpdate(params) {
        return request.put('/yhgl/update', params)
    },

    // 获取单位类型
    yhjsglGetAll() {
        return request.get('/yhgl/get_all')
    },

    // 根据ID查询详情
    yhjsglGetById(params) {
        return request.get('/yhgl/get_by_id', params)
    }

}